import { render, staticRenderFns } from "./CourseStream2.vue?vue&type=template&id=453939bb&"
import script from "./CourseStream2.vue?vue&type=script&lang=js&"
export * from "./CourseStream2.vue?vue&type=script&lang=js&"
import style0 from "./CourseStream2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports